import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customBox", "subscriptionBox"]

  customBoxChanged() {
    if (!this.customBoxTarget.checked) return

    this.subscriptionBoxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }

  subscriptionBoxChanged(event) {
    if (!event.target.checked) return

    if (this.hasCustomBoxTarget) {
      this.customBoxTarget.checked = false
    }
  }
}
